import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

import { createTheme, responsiveFontSizes } from "@mui/material/styles";
import { BrowserRouter as Router } from "react-router-dom";

import { CookiesProvider } from "react-cookie";
import { ToastContainer } from 'react-toastify'
// import { ToastContainer } from 'react-toast'
import "react-toastify/dist/ReactToastify.css";


let theme = createTheme({
  palette: {
    // mode: 'light', // or 'dark'
    // primary: {
    //   main: '#556cd6',
    // },
    // secondary: {
    //   main: '#19857b',
    // },
    // error: {
    //   main: '#red',
    // },
    // background: {
    //   default: '#fff',
    // },
    grey: {
      // Ensure grey shades are well-defined if you customize
      50: "#fafafa",
      100: "#f5f5f5",
      200: "#eeeeee",
      300: "#e0e0e0",
      // ... and so on
    },
  },
  // You can also customize typography, spacing, breakpoints, etc.
});

theme = responsiveFontSizes(theme); // Optional: for responsive font sizes

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(
  <React.Fragment>
    <ToastContainer position="top-right" />
    <CookiesProvider>
      <Router>
        <App />
      </Router>
    </CookiesProvider>
  </React.Fragment>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

